// extracted by mini-css-extract-plugin
export default {"container":"static-data_container__kDZyZ","content":"static-data_content__H+ipC"};